











import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import UserForm from './UserForm.vue';
import ChangePasswordForm from './ChangePasswordForm.vue';
import { User } from '@/types';
import { APP_UPDATE_PAGE_TITLE } from '@/store/mutypes';
import { userSvc } from '../../services';

@Component({
  name: 'user-edit',
  components: {
    UserForm,
    ChangePasswordForm
  }
})
export default class UserEdit extends Vue {
  @Prop({ required: true })
  private id!: number;

  @Getter
  isMe!: (id: number) => boolean;

  get canEditPassword() {
    return this.isMe(this.id);
  }

  private busy: boolean = false;
  private userLoaded: boolean = false;

  private user: User = {};

  async loadUser() {
    this.busy = true;
    try {
      this.user = await userSvc.getUser(this.id);
      this.userLoaded = true;
    } catch (e) {
      this.$notify.error('Fail to load user');
    }
    this.busy = false;
  }

  @Watch('user')
  onUserUpdate() {
    this.$store.commit(APP_UPDATE_PAGE_TITLE, `Edit ${this.user.name}`);
  }

  created() {
    this.loadUser();
  }
}
